export interface CardGroupType {
  cardGroupType?: MediaWrapperContainerTypeEnum | null;
  deviceType?: string;
}

export const getAspectRatioForBannerImages = (deviceType?: string) => {
  switch (deviceType) {
    case 'desktop':
    case 'browser':
      return { x: 3, y: 4.5 };
    case 'tablet':
      return { x: 4, y: 3 };
    case 'mobile':
      return { x: 4, y: 3 };
    default:
      return { x: 3, y: 4.5 };
  }
};

export const getAspectRatioForEndImages = (deviceType: string) => {
  switch (deviceType) {
    case 'desktop':
    case 'browser':
      return { x: 1, y: 1.95 };
    case 'tablet':
      return { x: 1, y: 2.2 };
    case 'mobile':
      return { x: 1, y: 2.2 };
    default:
      return { x: 1, y: 1.95 };
  }
};

export const getAspectRatioForBoutiqueImages = (deviceType: string) => {
  switch (deviceType) {
    case 'desktop':
    case 'browser':
      return { x: 4, y: 3 };
    case 'tablet':
      return { x: 3, y: 4 };
    case 'mobile':
      return { x: 3, y: 4 };
    default:
      return { x: 4, y: 3 };
  }
};

export const getImageScaleFromDiameter = (diameterInMillimeters: number) => {
  return diameterInMillimeters * 0.0281;
};

export const getAspectRatioForHeroBannerImages = (deviceType?: string) => {
  switch (deviceType) {
    case 'desktop':
    case 'browser':
      return { x: 15, y: 7 };
    case 'tablet':
      return { x: 15, y: 7 };
    case 'mobile':
      return { x: 75, y: 128 };
    default:
      return { x: 15, y: 7 };
  }
};

export const getAspectRatioByMediaBannerImages = (deviceType?: string) => {
  switch (deviceType) {
    case 'desktop':
    case 'browser':
      return { x: 10, y: 3 };
    case 'tablet':
      return { x: 10, y: 3 };
    case 'mobile':
      return { x: 4, y: 4.5 };
    default:
      return { x: 10, y: 3 };
  }
};
export const getAspectRatioByMediaAndBottomTextImages = ({
  cardGroupType,
  deviceType,
}: CardGroupType) => {
  switch (cardGroupType) {
    case 'Grid':
    case 'ThreeColumnScroll':
    case 'ThreeColumnStack':
      return { x: 16, y: 9 };
    default:
      switch (deviceType) {
        case 'desktop':
        case 'browser':
          return { x: 36, y: 8 };
        case 'tablet':
          return { x: 36, y: 8 };
        case 'mobile':
          return { x: 17, y: 10 };
        default:
          return { x: 36, y: 8 };
      }
  }
};

export const getAspectRatioByMyAccountCol12CardImages = (
  deviceType?: string,
) => {
  switch (deviceType) {
    case 'desktop':
      return { x: 5, y: 7 };
    case 'tablet':
      return { x: 5, y: 7 };
    case 'mobile':
      return { x: 1, y: 1 };
    default:
      return { x: 5, y: 7 };
  }
};

export const getAspectRatioByMyAccountCol6CardImages = (
  deviceType?: string,
) => {
  switch (deviceType) {
    case 'desktop':
      return { x: 5, y: 3.5 };
    case 'tablet':
      return { x: 5, y: 3.5 };
    case 'mobile':
      return { x: 1, y: 1 };
    default:
      return { x: 5, y: 3.5 };
  }
};

export type MediaWrapperTypeEnum =
  | 'BannerImage'
  | 'MediaBanner'
  | 'MediaAndBottomText'
  | 'MediaAndSideText'
  | 'MediaAndWatch'
  | 'ImageAndDidYouKnow'
  | 'ImageTeaser'
  | 'SquadCard'
  | 'SectionBanner'
  | 'TopBanner'
  | 'FourColumnScroll'
  | 'ThreeColumnTeaser'
  | 'ThreeColumnStack'
  | 'ThreeColumnScroll'
  | 'DoubleCard'
  | 'HeroSlider'
  | 'MyAccount12'
  | 'MyAccount6'
  | 'HeroBanner'
  | 'NarrowMediaAndBottomText'
  | 'Auto'
  | 'SliderFullwidthGallery'
  | 'Story'
  | 'HistoriesItem'
  | 'WarrantyPlaceholderDeskTop'
  | 'WarrantyPlaceholderMobile'
  | '3by4Media'
  | 'GenericCountdownCard';

export enum MediaWrapperContainerTypeEnum {
  Grid = 'Grid',
  FourColumnScroll = 'FourColumnScroll',
  ThreeColumnTeaser = 'ThreeColumnTeaser',
  ThreeColumnStack = 'ThreeColumnStack',
  ThreeColumnScroll = 'ThreeColumnScroll',
  DoubleCard = 'DoubleCard',
  HeroSlider = 'HeroSlider',
}

export const getAspectRatioForImages = (
  mediaWrapperType?: MediaWrapperTypeEnum,
  cardGroupType?: MediaWrapperContainerTypeEnum | null,
  width?: number | null,
  height?: number | null,
  deviceType?: string,
) => {
  switch (mediaWrapperType) {
    case 'BannerImage':
      return getAspectRatioForBannerImages(deviceType);
    case 'MediaBanner':
      return getAspectRatioByMediaBannerImages(deviceType);
    case 'MediaAndBottomText':
      return getAspectRatioByMediaAndBottomTextImages({
        cardGroupType,
        deviceType,
      });
    case 'MediaAndSideText':
      return getAspectRatioByWidthHeight(width, height);
    case 'MediaAndWatch':
      return { x: 20, y: 17 };
    case 'ImageAndDidYouKnow':
      return { x: 20, y: 17 };
    case 'ImageTeaser':
      return { x: 16, y: 9 };
    case 'SquadCard':
    case 'NarrowMediaAndBottomText':
      return { x: 4, y: 5 };
    case 'SectionBanner':
      return { x: 4, y: 3 };
    case 'TopBanner':
      switch (deviceType) {
        case 'desktop':
          return { x: 36, y: 8 };
        case 'mobile':
          return { x: 17, y: 10 };
        default:
          return { x: 36, y: 8 };
      }
    case 'FourColumnScroll':
    case 'Story':
      return { x: 101, y: 133 };
    case 'ThreeColumnTeaser':
      return { x: 1, y: 1 };
    case 'ThreeColumnStack':
      return { x: 1, y: 1 };
    case 'ThreeColumnScroll':
      return { x: 1, y: 1 };
    case 'DoubleCard':
      return { x: 1, y: 1 };
    case 'MyAccount12':
      return getAspectRatioByMyAccountCol12CardImages(deviceType);
    case 'MyAccount6':
      return getAspectRatioByMyAccountCol6CardImages(deviceType);
    case 'HeroBanner':
      return getAspectRatioForHeroBannerImages(deviceType);
    case 'Auto':
      return getAspectRatioByWidthHeight(width, height);
    case 'SliderFullwidthGallery':
    case '3by4Media':
      return { x: 3, y: 4 };
    case 'HistoriesItem':
      return { x: 39, y: 53 };
    case 'WarrantyPlaceholderDeskTop':
      return { x: 274, y: 441 };
    case 'WarrantyPlaceholderMobile':
      return { x: 1, y: 1 };
    case 'GenericCountdownCard':
      return getAspectRatioByCountDownImages(deviceType, width, height);
    default:
      return { x: 4, y: 3 };
  }
};

const getAspectRatioByWidthHeight = (
  width?: number | null,
  height?: number | null,
) => {
  if (width && height) {
    return { x: width, y: height };
  }
  return { x: 1, y: 1 };
};

export const calculateCroppedDimensions = (
  imageDimensions: { height: number; width: number },
  aspectRatioWidth: number,
  aspectRatioHeight: number,
): { croppedHeight: number; croppedWidth: number } => {
  const { height, width } = imageDimensions;
  const originalAspectRatio = width / height;
  const desiredAspectRatio = aspectRatioWidth / aspectRatioHeight;

  if (originalAspectRatio > desiredAspectRatio) {
    return {
      croppedWidth: Math.round(height * desiredAspectRatio),
      croppedHeight: Math.round(height),
    };
  }
  if (originalAspectRatio < desiredAspectRatio) {
    return {
      croppedWidth: Math.round(width),
      croppedHeight: Math.round(width / desiredAspectRatio),
    };
  }

  return {
    croppedWidth: Math.round(width),
    croppedHeight: Math.round(height),
  };
};

export const getAspectRatioByCountDownImages = (
  deviceType?: string,
  width?: number | null,
  height?: number | null,
) => {
  if (width && height) {
    return { x: width, y: height };
  } else if (deviceType === 'mobile') {
    return { x: 375, y: 424 };
  }
  return { x: 1440, y: 486 };
};
